import { Injectable } from '@angular/core';
import { User } from 'src/app/models/auth/user';

@Injectable({
  providedIn: 'root'
})
export class UserSessionService {

  constructor() { }

  setToken(data: string): void {
    localStorage.setItem('token', data);
  }

  getToken(): User {
    // console.log(localStorage.getItem('token'));
    return JSON.parse(localStorage.getItem('token'));
  }

  removeToken(): void {
    localStorage.removeItem('token');
  }

  obtenerPermisosToken(): string[] {
    return JSON.parse(localStorage.getItem('token')).permission;
  }

  obtenerUsuarioId(): number {
    return JSON.parse(localStorage.getItem('token')).id;
  }

  // obtenerAtributosPersonaDeToken(atributos: string[]) {
  //   let personaAux = JSON.parse(localStorage.getItem('token')).persona;
  //   let persona = new Persona();
  //   atributos.forEach(attr => {
  //     persona[attr] = personaAux[attr];
  //   });
  //   return persona;
  // }
}
